module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "外教离职",
      "width": "520px",
      "class-name": "resign-modal"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "resign-content"
  }, [_c('div', {
    staticClass: "resign-tip"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle",
      "size": "20",
      "color": "#E6A23C"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('Form', {
    ref: "leaveForm",
    attrs: {
      "label-width": 120,
      "model": _vm.leaveParam,
      "rules": _vm.leaveRule
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "离职类型",
      "prop": "resignType",
      "required": ""
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.leaveParam.resignType),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "resignType", $$v)
      },
      expression: "leaveParam.resignType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("离职")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("淘汰")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("失联")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "最后工作日期",
      "prop": "lastWorkDay"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择最后工作日期"
    },
    on: {
      "on-change": _vm.startTimeChange
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "离职理由",
      "prop": "resignReason"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 200,
      "placeholder": "请输入离职理由（选填）",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.leaveParam.resignReason),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "resignReason", $$v)
      },
      expression: "leaveParam.resignReason"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "议后是否再录用",
      "prop": "rehireFlag"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.leaveParam.rehireFlag),
      callback: function($$v) {
        _vm.$set(_vm.leaveParam, "rehireFlag", $$v)
      },
      expression: "leaveParam.rehireFlag"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("确认离职")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e428086","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/ResignModal.vue
// module id = 1904
// module chunks = 8